<template>
    <div class="configResume">
        <ConfigResumeHeader :isMain="true" v-on="$listeners"/>
        <div class="configResume-price">
            <span>Preço total desde</span>
            <h2>{{ getPrice | format_thousands}} €
                <svg @click="openModal(isCredit ? true : false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
            </h2>
        </div>
        <div class="configResume-rent">
            <span>Mensalidade</span>
            <div>
                <h2>{{ resumeData.rent | format_thousands(true)}} € </h2>
                <h2 class="taeg">TAEG: {{ parseFloat(resumeData.taeg).toFixed(1) | format_thousands(true, 1)}}%</h2>
            </div>
        </div>
        <p class="configResume-info" v-html="handleInfoSectionContent"></p>

        <div class="configResume-btns">
            <button class="btn-primary" @click="openFormMTD">Marcar Test-Drive</button>
            <button class="btn-primary" @click="openFormPropose">Pedir Proposta</button>
            <router-link  class="btn-primary-rightIcon" to="/"> {{ gama }} Nova Configuração</router-link>
        </div>
        <div class="wrap separator" v-if="dataBO.hasSimul">
            <p v-show="isMobile" class="btn-secondary" @click="showFinances">Financiamento</p>
        </div>
        <ClickToBuy />
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex';
    import ConfigResumeHeader from './ConfigResumeHeader.vue'
    import { modalForms } from '../../../mixins/modalForms'
    import { modalPrice } from '../../../mixins/modalFunctions'
    import { formatContent } from '../../../mixins/comonFunctions'
    import ClickToBuy from '../ClickToBuy/ClickToBuy.vue'

    export default {
        name: 'ConfigResume',
        components:{ ConfigResumeHeader, ClickToBuy },
        mixins: [modalForms, modalPrice, formatContent],
        props:{
            isMobile: {type: Boolean, default: false},
        },
        data(){return{
            modalParam: 2,
        }},
        computed: {
            ...mapState(['resumeData', 'dataBO']),
            ...mapGetters({
                modelPrice: 'resumeData/getFullPrice',
                getModelNameById: 'getModelNameById',
            }),
            handleInfoSectionContent(){
                let rD = this.resumeData;
                let finance = rD.basePrice - rD.incialEntry
                let financeMount = parseFloat(finance).toFixed(0)
                let txt = `${rD.maxMounths}  meses.<br>Entrada inicial: ${this.format_thousands(rD.incialEntry)} €.<br>Montante Financiado: ${this.format_thousands(financeMount)} €`;
                return this.isCredit ? txt : txt + `<br>Última Mensalidade: ${ this.format_thousands(rD.hasFinances.residualValue) } €`
            },
            getPDFLink(){
                let pdfinBase64 = this.resumeData.pdfinBase64
                if(pdfinBase64) return"data:application/pdf;base64," + escape(pdfinBase64)
                return false
            },
            isCredit(){
                return this.resumeData.creditType == 'CREDIT'
            },
            getPrice(){ return this.isCredit ? this.resumeData.basePrice : this.resumeData.hasFinances.pvp },
        },
        methods:{
            openModal(hodOrCredit){
                this.$store.commit('modalData/UPDATE_MODALSTATE', {
                    openModal: true,
                    component: 'DefaultModalContent',
                    title: this.setModalTitle(this.handleModalFinTitle, false),
                    content: this.setFinanceContent(hodOrCredit, this.handleModalFinData),
                });
                document.body.classList.add('isActive')
            },
            showFinances(){
                this.$emit('display-finances', true);
            },
            generateLink(){
                let url = window.location.origin
                let modelid = this.resumeData.modelid
                let engine = this.resumeData.selectedEngine
                let version = this.resumeData.versionID
                let colExt = this.resumeData.configSelected.dsgExt?.colorid
                let colInt = this.resumeData.configSelected.dsgInt?.colorid
                let path = process.env.VUE_APP_BASE

                let copyLink = `${url}/${path}?modelid=${modelid}&engine=${engine}&version=${version}&colext=${colExt}&colint=${colInt}`
                // only https works, else return undefined, avoid abuse they say
                navigator.clipboard.writeText(copyLink)
            }
        },
    }
</script>
<style lang="scss">
    @import './ConfigResume.scss';
</style>
